import React from 'react';
export const GlobalMarket = ({
  color = 'currentColor',
  width = '12px',
  height = '12px',
  ...props
}) => {
  return (
<svg  xmlns="http://www.w3.org/2000/svg" 
width={width}
height={height}
 {...props}
	 viewBox="0 0 32 32" >
<path d="M31,15.64H16.724l3.716-4.904c0.172,0.078,0.36,0.124,0.56,0.124c0.299,0,0.573-0.1,0.798-0.264
	l1.952,1.87C23.68,12.63,23.64,12.81,23.64,13c0,0.75,0.61,1.36,1.36,1.36s1.36-0.61,1.36-1.36c0-0.294-0.096-0.564-0.255-0.787
	l3.321-3.985C29.601,8.31,29.794,8.36,30,8.36c0.75,0,1.36-0.61,1.36-1.36S30.75,5.64,30,5.64S28.64,6.25,28.64,7
	c0,0.283,0.087,0.546,0.236,0.764l-3.328,3.993C25.38,11.683,25.195,11.64,25,11.64c-0.299,0-0.573,0.1-0.797,0.263l-1.952-1.87
	c0.07-0.164,0.11-0.344,0.11-0.533c0-0.75-0.61-1.36-1.36-1.36s-1.36,0.61-1.36,1.36c0,0.289,0.092,0.556,0.246,0.776l-3.526,4.653
	V1.376c3.241,0.08,6.342,1.228,8.851,3.264h-2.22v0.72h3.37V2H25.64v2.061C22.914,1.858,19.525,0.64,16,0.64l0,0l0,0l0,0l0,0
	C7.53,0.64,0.64,7.53,0.64,16c0,0.199,0.161,0.36,0.36,0.36h14.64v14.263c-3.239-0.08-6.342-1.227-8.851-3.263H9.01v-0.72H5.64V30
	h0.72v-2.062c2.726,2.203,6.117,3.422,9.64,3.422c8.47,0,15.36-6.891,15.36-15.36C31.36,15.801,31.199,15.64,31,15.64z M16.36,23.86
	h5.653c-1.209,3.873-3.279,6.497-5.653,6.742V23.86z M16.36,23.14v-6.78h6.771c-0.029,2.457-0.352,4.764-0.904,6.78H16.36z M30,6.36
	c0.353,0,0.64,0.287,0.64,0.64S30.353,7.64,30,7.64S29.36,7.353,29.36,7S29.647,6.36,30,6.36z M25,12.36
	c0.353,0,0.64,0.287,0.64,0.64s-0.287,0.64-0.64,0.64s-0.64-0.287-0.64-0.64S24.647,12.36,25,12.36z M21,8.86
	c0.353,0,0.64,0.287,0.64,0.64s-0.287,0.64-0.64,0.64s-0.64-0.287-0.64-0.64S20.647,8.86,21,8.86z M15.64,8.14H9.986
	c1.209-3.874,3.279-6.498,5.654-6.743C15.64,1.397,15.64,8.14,15.64,8.14z M13.241,1.636C11.567,2.868,10.167,5.179,9.26,8.14H3.67
	C5.799,4.813,9.228,2.406,13.241,1.636z M3.225,8.86h5.821c-0.549,2.035-0.868,4.338-0.897,6.78H1.364
	C1.424,13.183,2.094,10.876,3.225,8.86z M8.869,15.64c0.029-2.457,0.352-4.765,0.904-6.78h5.868v6.78
	C15.641,15.64,8.869,15.64,8.869,15.64z M18.76,30.364c1.673-1.232,3.073-3.543,3.981-6.504h5.589
	C26.201,27.187,22.773,29.594,18.76,30.364z M28.775,23.14h-5.821c0.549-2.035,0.868-4.337,0.897-6.78h6.785
	C30.576,18.817,29.906,21.124,28.775,23.14z M14.36,24v-6c0-0.199-0.161-0.36-0.36-0.36H2c-0.199,0-0.36,0.161-0.36,0.36v6
	c0,0.199,0.161,0.36,0.36,0.36h12C14.199,24.36,14.36,24.199,14.36,24z M11.677,23.64H4.323c-0.157-1.012-0.952-1.807-1.964-1.964
	v-1.352c1.012-0.157,1.807-0.952,1.964-1.964h7.353c0.157,1.012,0.952,1.807,1.964,1.964v1.352
	C12.629,21.833,11.833,22.628,11.677,23.64z M13.64,19.597c-0.615-0.139-1.099-0.622-1.237-1.237h1.237
	C13.64,18.36,13.64,19.597,13.64,19.597z M3.597,18.36c-0.139,0.615-0.623,1.098-1.237,1.237V18.36H3.597z M2.36,22.403
	c0.615,0.139,1.099,0.622,1.237,1.237H2.36V22.403z M12.403,23.64c0.139-0.615,0.623-1.098,1.237-1.237v1.237H12.403z M8,19.64
	c-0.75,0-1.36,0.61-1.36,1.36S7.25,22.36,8,22.36S9.36,21.75,9.36,21S8.75,19.64,8,19.64z M8,21.64c-0.353,0-0.64-0.287-0.64-0.64
	S7.647,20.36,8,20.36c0.353,0,0.64,0.287,0.64,0.64S8.353,21.64,8,21.64z M4,20.64h1v0.721H4V20.64z M11,20.64h1v0.721h-1V20.64z"/>

</svg>
  );
};
